import SFetch from '@app/utils/sfetch'
import type { AdjustmentsData, DetailedEntriesData, Top5Item } from '../types'
import reportDisplayParams from '../utils/report-display-params'

export interface AccountDataResponse {
  periodLabel: string
  accountTitle: string
  accountSubtitle: string | null
  accountNumber: string
  accountLedgerUrl: string
  entryPresent: boolean
  top5: Array<Top5Item>
  currencyNegativeFormat: string
  detailedEntries: DetailedEntriesData
  adjustments: AdjustmentsData
  canAddMessage: boolean
}

export async function getAccountData(
  reportId: number,
  accountId: number,
  ledgerId: number,
  subtractLedgerId: number,
  relative: string,
  analyticalDimensionId?: number
): Promise<AccountDataResponse | void | null> {
  const url = window.Silverfin.Routes.account_details_report_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    reportId
  )
  const params = new URLSearchParams({
    account_id: String(accountId),
    relative,
    main_ledger_id: String(ledgerId),
    subtract_ledger_id: String(subtractLedgerId || ''),
  })
  if (analyticalDimensionId) {
    params.set('analytical_dimension_id', String(analyticalDimensionId))
  }
  for (const [key, value] of Object.entries(reportDisplayParams())) {
    params.set(key, value)
  }

  return await SFetch.json<AccountDataResponse>(`${url}?${params}`)
}
